export default __webpack_public_path__ + "static/media/idea.edf5dc7f.svg";